//@ts-nocheck
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import styled, { css } from "styled-components";
import { IrisColors } from "./../css/IRISColors";

import ChangePasswordForm from "./../components/ChangePasswordForm";
import { findReportViaURLPath } from "./DashboardReportsInfo";
import DashboardFooter from "./DashboardFooter";
import DashboardReportActionsBar from "./DashboardReportActionsBar";

import { DashboardSidebarMenuItems } from "./DashboardSidebarMenu";

const formatCitationReleaseDate = (dateStr) => {
    if (!dateStr) return 'Date not available';
    const parsed = new Date(dateStr);
    if (!isNaN(parsed.getTime())) {
        const formatted = parsed.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        if (formatted !== 'Invalid Date') return formatted;
    }
    return dateStr;
};

const DashboardContainer = ({ children, title }) => {

    const displayId = useSelector(state => state.userProperties.display_id);
    const reportDisplayId = useSelector(state => state.userProperties.report_display_id);
    const username = useSelector(state => state.userProperties.username);
    const fullname = useSelector(state => `${state.userProperties.firstname} ${state.userProperties.lastname}`);
    const universityName = useSelector(state => state.userProperties.university);
    const cdfs = useSelector(state => state.userProperties.FactSheetList);
    const slfs = useSelector(state => state.userProperties.UniversityListStateReport);
    const cddr = useSelector(state => state.userProperties.UniversityListDetailedDistrictReport);
    const cddrReportConfig = useSelector(state => state.detailedDistrictReportProperties.reportConfig);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [collapseSidebar, setCollapseSidebar] = useState(false);
    const [releaseDate, setReleaseDate] = useState("");

    const { match } = children.props;

    const isReport = match.path !== "/reports" && match.path.includes("/reports");

    const currentReport = isReport ? findReportViaURLPath(match.url) : null;
    
    useEffect(() => {
        if (!currentReport) return;

        let rDate;
        switch (currentReport.nameID) {
            case "CONGRESSIONAL_DISTRICT_DETAIL_REPORT": {
                const ddDate = cddrReportConfig?.release_date
                    ?? cddr.find(x => String(x.display_id) === String(reportDisplayId ?? displayId))?.release_date;
                rDate = formatCitationReleaseDate(ddDate);
                break;
            }
            case "STATE_LEGISLATIVE_FACTSHEET": {
                const slDate = slfs.find(x => String(x.display_id) === String(reportDisplayId ?? displayId))?.release_date;
                rDate = formatCitationReleaseDate(slDate);
                break;
            }
            case "CONGRESSIONAL_DISTRICT_FACTSHEET": {
                const fsDate = cdfs.find(x => String(x.display_id) === String(reportDisplayId ?? displayId))?.release_date;
                rDate = formatCitationReleaseDate(fsDate);
                break;
            }
        }
        setReleaseDate(rDate);
    }, [currentReport, cddr, slfs, cdfs, cddrReportConfig, displayId, reportDisplayId]);

    const currentSubmissionDeadline = () => {
        let currentDeadline = "";
        const today = new Date();
        const aprilNextYear = new Date(today.getFullYear() + 1, 3, 15);
        const aprilThisYear = new Date(today.getFullYear(), 3, 15);
        const octoberLastYear = new Date(today.getFullYear() - 1, 9, 15);
        const octoberThisYear = new Date(today.getFullYear(), 9, 15);

        if (today > octoberLastYear && today < aprilThisYear) {
            currentDeadline = "April 15, " + today.getFullYear();
        } else if (today > octoberThisYear && today < aprilNextYear) {
            currentDeadline = "April 15, " + (today.getFullYear() + 1);
        } else {
            currentDeadline = "October 15, " + today.getFullYear();
        }
        return currentDeadline;
    };
    
    return (
        <Wrapper>
            <ChangePasswordForm username={username} showPasswordModal={showPasswordModal} handleClose={() => setShowPasswordModal(false)} />
            <Sidebar collapsed={collapseSidebar}>
                <LogoContainer>
                    <img className="img-fluid brand-header-logo" src={collapseSidebar ? String(iris_logo_icon_white) : String(iris_logo_white)} alt='IRIS Logo' />
                </LogoContainer>
                <Hr />
                <ToggleContainer collapsed={collapseSidebar}>
                    {!collapseSidebar && <DashboardText white bold>Menu: </DashboardText>}
                    <SidebarCollapseToggle collapsed={collapseSidebar} onClick={() => setCollapseSidebar(!collapseSidebar)}>
                        <SidebarToggleIcon collapsedSidebar={true} className={collapseSidebar ? "glyphicon glyphicon-menu-right" : "glyphicon glyphicon-menu-left"} />
                    </SidebarCollapseToggle>
                </ToggleContainer>
                <Hr light />
                <SidebarNavContainer>
                    {
                        DashboardSidebarMenuItems.map((menuItem) => {
                            if ((menuItem.name != "Benchmarking") || (menuItem.name == "Benchmarking" && username == "testadmin@umich.edu"))
                                return (
                                    <SidebarNavLink key={menuItem.id} to={menuItem.link} activeStyle={{ backgroundColor: `${IrisColors.secondaryBlue}` }}>
                                        <NavIcon collapsedSidebar={collapseSidebar} className={menuItem.iconClass}></NavIcon>
                                        {!collapseSidebar && <NavText>{menuItem.name}</NavText>}
                                    </SidebarNavLink>
                                )
                        })
                    }
                </SidebarNavContainer>
                <SidebarBottomDiv>
                    {
                        !collapseSidebar &&
                        <>
                            <DashboardText white bold>For Questions & Feedback:</DashboardText>
                            <DashboardText white >· Call 734-615-0015 or</DashboardText>
                            <DashboardText white >· Email IRIS-info@umich.edu</DashboardText>
                        </>
                    }
                </SidebarBottomDiv>
            </Sidebar>
            <MainPanel collapsedSidebar={collapseSidebar}>
                <Header>
                    <HeaderTextContainer>
                        <HeaderTitle>IRIS Portal</HeaderTitle>
                        <HeaderTitle>{title}</HeaderTitle>
                    </HeaderTextContainer>
                    <ProfileInfoAndLogoContainer>
                        <SubmissionDeadlineDiv>
                            <DashboardText white bold>Data Submission Deadline:</DashboardText>
                            <DashboardText white >{currentSubmissionDeadline()}</DashboardText>
                        </SubmissionDeadlineDiv>
                        <ChangePasswordButton onClick={() => setShowPasswordModal(true)}>
                            <PadlockIcon className="fa fa-lock lock"></PadlockIcon>
                            <DashboardText white >Change Password</DashboardText>
                        </ChangePasswordButton>
                        <DashboardTextContainer>
                            <DashboardText white >{fullname}</DashboardText>
                            <DashboardText white >{universityName}</DashboardText>
                            <DashboardText white >{username}</DashboardText>
                        </DashboardTextContainer>
                        <UniversityLogoContainer>
                            <UniversityLogo src={university_logo(displayId)} alt="" />
                        </UniversityLogoContainer>
                    </ProfileInfoAndLogoContainer>
                </Header>
                <MainPanelBody>
                    <ReportContainer>
                        {children}
                    </ReportContainer>
                </MainPanelBody>
                <DashboardFooter currentReport={currentReport} isReport={isReport} releaseDate={releaseDate} />
            </MainPanel>
        </Wrapper>
    );
}

// dashboard css constants
const fullsideBarWidth = "260px";
const minimizedSideBarWidth = "70px";

/**
 * Styled component: Wrapper for entire portal
 * */
const Wrapper = styled.div`
    position: relative;
    top: 0;
    height: 100vh;
`;

/**
 * Styled component: sidebar menu for dashboard
 * */
const Sidebar = styled.div`
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    max-width: ${props => props.collapsed ? minimizedSideBarWidth : fullsideBarWidth};
    height: 100vh;
    background-color: ${IrisColors.irisLogoBlue};
    padding: 10px;
    box-shadow: 0px 2px 4px #9e9e9e;
    z-index: 2;
`;

const iris_logo_icon_white = require('./../images/IRIS_Logo_icon_white.png');
const iris_logo_white = require('./../images/IRIS_Logo_White.png');

/**
 * Function: gets the URI string for a member university logo
 * @param universityDisplayID
 */
const university_logo = (universityDisplayID: string | number): string => require(`./../images/univ_logos/${universityDisplayID}.png`);

/**
 * Styled component: container for IRIS logo on portal
 * */
const LogoContainer = styled.div`
    display: flex;
    width: 100%;
    min-height: 50px;
    margin-block: 10px;
`;

/**
 * Styled component: sidebar navigation container for navigation links
 * */
const SidebarNavContainer = styled.div`
    display: grid;
    gap: 5px;
`;

/**
 * Styled component: sidebar navigation link
 * */
const SidebarNavLink = styled(NavLink)`
    display: flex;
    align-items: center;
    width: 100%;
    padding-inline: 15px;
    padding-block: 15px;
    border-radius: 3px;

    &:hover {
        text-decoration: none;
        background-color: ${IrisColors.secondaryBlue};
    }
`;


const NavIcon = styled.span`
    font-size: 2rem;
    margin-right: ${props => props.collapsedSidebar ? "0px": "10px"};
    color: ${IrisColors.white};
`;

const NavText = styled.span`
    font-size: 1.5rem;
    font-weight: 600;
    color: ${IrisColors.white};
`;

const Hr = styled.hr`
    background: ${IrisColors.white};
    width: 100%;
    ${props => props.light && css`
        opacity: 0.2;
    `}
`;

const SidebarBottomDiv = styled.div`
    margin-top: auto;
    width: 100%;
    padding: 10px;
`;

// Sidebar toggle
const ToggleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline: ${props => props.collapsed ? "12.5px" : "15px"};
`;

const SidebarCollapseToggle = styled.div`
    display: flex;
    padding: .7rem;
    height: 25px;
    width: 25px;
    margin-block: 8px;
    border-radius: 50%;
    color: #fff;
    background-color: ${IrisColors.secondaryBlue};
    opacity: 0.7;
`;

const SidebarToggleIcon = styled(NavIcon)`
    font-size: 1.1rem;
`;

/**
 * Styled component: Main panel
 * */
const MainPanel = styled.div`
    position: relative;
    float: right;
    width: calc(100% - ${props => props.collapsedSidebar ? minimizedSideBarWidth : fullsideBarWidth});
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${IrisColors.backgroundGrey};
`;

const Header = styled.div`
    position: fixed;
    display: flex;
    justify-content: space-between;
    top: 0;
    width: inherit;
    height: 90px;
    padding-inline: 15px;
    padding-block: 10px;
    background-color: ${IrisColors.irisLogoBlue};
    box-shadow: 4px 1px 4px ${IrisColors.shadow};
    z-index: 1;
`;

const ProfileInfoAndLogoContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    max-height: 100%;
`;

const DashboardTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
    margin-inline: 15px;
`;

export const DashboardText = styled.p`
    font-size: 1.5rem;
    font-weight: 500;
    margin: 0px;

    ${props => props.white && css`
        color: ${IrisColors.white};
    `}

    ${props => props.bold && css`
        font-weight: 700;
    `}
`;

const UniversityLogoContainer = styled.div`
    max-height: 100%;
    max-width: 75px;
`;

const UniversityLogo = styled.img`
    max-height: 60px;
    max-width: 60px;
    object-fit: contain;
`;

const HeaderTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: left;
    height: 100%;
`;

const HeaderTitle = styled.p`
    font-size: 2rem;
    font-weight: 600;
    color: ${IrisColors.white};
    margin-bottom: 0px;
`;

/**
 * Styled component: change password button in header
 * */
const ChangePasswordButton = styled.a`
    display: grid;
    gap: 10px;
    justify-content: center;
    width: 175px;
    height: 100%;
    color: ${IrisColors.white};
    border-right: 2px solid ${IrisColors.white};
    &:hover {
        text-decoration: none;
        color: ${IrisColors.white};
        cursor: pointer;
    }
`;

/**
 * Styled component: submission dealine div
 * */
const SubmissionDeadlineDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 225px;
    height: 100%;
    color: ${IrisColors.white};
    border-right: 2px solid ${IrisColors.white};
`;

/**
 * Styled component: padlock font-awesome icon
 * */
const PadlockIcon = styled.i`
    font-size: 24px;
`;

// main panel body
const MainPanelBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    padding-inline: 15px;
    padding-top: 105px;
    background-color: ${IrisColors.backgroundGrey};
`;

const ActionsBar = styled.div`
    dispay: flex;
    justify-content: space-between;
    width: 100%;
    height: 35px;
    padding-inline: 15px;
    padding-block: 5px;
    margin-bottom: 10px;
    border-radius: 5px;
    background-color: ${IrisColors.white};
`;

const ActionButton = styled(Link)`
    height: 100%;
    font-size: 15px;
    color: ${IrisColors.irisLogoBlue};
    &:hover {
        text-decoration: none;
        color: ${IrisColors.irisLogoRed};
        cursor: pointer;
    }
`;

const ReportContainer = styled.div`
    display: flex;
    justify-content: center;
    min-height: 85vh;
    padding-block: 15px;
    border-radius: 5px 5px 0px 0px;
    background-color: ${IrisColors.white};
`;


export default DashboardContainer;